/* eslint-disable react/destructuring-assignment */
import GenericPage from '@components/page-renderer/generic-page/generic-page.view';
import StylistPage from 'features/stylist-page';
import type { ReactElement } from 'react';
import type { PageData } from 'types/page';
import type SiteContext from 'types/site-context';

interface Props {
  readonly page: PageData;
  readonly context: SiteContext;
}

export type PageMapper = ({ context, page }: Props) => ReactElement | undefined;

// eslint-disable-next-line react/function-component-definition
export const DEFAULT_PAGE_MAPPER: PageMapper = function ({
  context,
  page,
}: Props): ReactElement | undefined {
  switch (page._type) {
    case 'page': {
      return <GenericPage context={context} {...page} />;
    }

    case 'stylist': {
      return <StylistPage context={context} {...page} />;
    }
    default: {
      return undefined;
    }
  }
};
